import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { useCallback } from "react";
import { CustomDimensionType } from "../models/CustomDimensionType";
import { useLocation } from "react-router";

type ISuggestionDataState = {
  requestId?: string;
  requestSuggestionId?: string;
}

export const getSuggestionDataState = (
  requestId?: string, 
  requestSuggestionId?: string
): ISuggestionDataState => {
  return {
    requestId: requestId,
    requestSuggestionId: requestSuggestionId
  }
}

interface IKlasisTrackPageViewResponse {
  suggestionRequestId: string;
}

interface IKlasisTrackSiteSearchProps {
  searchPhrase: string;
  requestId: string;
}

const useKlasisTracker = () => {
  const { trackPageView, trackSiteSearch } = useMatomo();
  const location = useLocation();
  const { pushInstruction } = useMatomo();

  const klasisTrackSiteSearch = useCallback(
    (props: IKlasisTrackSiteSearchProps): void => {
      trackSiteSearch({
        keyword: props.searchPhrase,
        customDimensions: [ 
          { id: CustomDimensionType.requestId, value: props.requestId }
        ] 
      });
    },
    []
  )

  const klasisTrackPageView = useCallback(
    (): IKlasisTrackPageViewResponse => {
      if (location.state 
        && 'requestId' in location.state 
        && 'requestSuggestionId' in location.state
      ) {
        const suggestionDataState = location.state as ISuggestionDataState;

        trackPageView({
          customDimensions: [
            { id: CustomDimensionType.requestId, value: suggestionDataState.requestId },
            { id: CustomDimensionType.requestSuggestionId, value: suggestionDataState.requestSuggestionId }
          ] 
        });

        window.history.replaceState({}, document.title);

        return {
          suggestionRequestId: suggestionDataState.requestSuggestionId ?? ''
        };
      }

      pushInstruction("deleteCustomDimension", [CustomDimensionType.requestId]);
      pushInstruction("deleteCustomDimension", [CustomDimensionType.requestSuggestionId]);

      trackPageView();

      return {
        suggestionRequestId: ''
      };
    },
    []
  )

  return {
    klasisTrackPageView,
    klasisTrackSiteSearch
  };
}

export default useKlasisTracker;